import * as React from 'react';

export interface IHertzPrivacyPolicyUIStateProps {
    dealerName?: string;
}
/* tslint:disable:max-line-length */
export const HertzPrivacyPolicyContentUI: React.ComponentType<IHertzPrivacyPolicyUIStateProps> = (props: IHertzPrivacyPolicyUIStateProps) => {
    return (
        <div>
        <div className="span12">
            <h2 style={{ textAlign:'center' }}>THE HERTZ CORPORATION</h2>
            <h2 id="top" style={{ textAlign:'center' }}><u>PRIVACY POLICY</u></h2>
            <p>
            The Hertz Corporation, its rental and other rental-related businesses, business affiliates, and subsidiaries,
            including Dollar, Thrifty, and Firefly (together “We”, “Us”, and “Our”) respects the privacy rights of Our
            customers and We are committed to protecting your privacy. This Privacy Policy (the “Policy”) explains Our data
            handling practices as a “Controller” with regard to your Personal Data, as well as your rights associated with
            your Personal Data. This Policy was last materially updated on May 20, 2018.
            </p>

            <ul style={{ listStyleType:'none' }}>
                <li>
                 <a href="#1"><u>Quick Reference Guide</u></a>
                </li>
                <li>
                 <a href="#2"><u>Scope and Controllers</u></a>
                </li>
                <li>
                 <a href="#3"><u>Data collection (what & how)</u></a>
                </li>
                <li>
                 <a href="#4"><u>Purposes for processing</u></a>
                </li>
                <li>
                 <a href="#5"><u>3rd party recipients</u></a>
                </li>
                <li>
                 <a href="#6"><u>International transfers</u></a>
                </li>
                <li>
                 <a href="#7"><u>Cookies and Online Advertising Choices</u></a>
                </li>
                <li>
                 <a href="#8"><u>Security</u></a>
                </li>
                <li>
                 <a href="#7"><u>Data retention and integrity</u></a>
                </li>
                <li>
                 <a href="#8"><u>Access, correction, and portability</u></a>
                </li>
                <li>
                 <a href="#9"><u>Withdraw consent or Complaints</u></a>
                </li>
                <li>
                 <a href="#10"><u>Contact Us</u></a>
                </li>
                <li>
                 <a href="#11"><u>Changes</u></a>
                </li>
            </ul>


            <h4 id="1">A. Quick Reference Guide </h4>
            <h5>
                1. Scope
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                This policy covers the information We obtain from you in connection with Our vehicle rental and
                other associated businesses, which identifies you as an individual.
                </li>
                <li>This policy does not cover information that cannot be used to identify you as an individual.</li>
            </ul>
            <h5>
                 2. Information We collect (what &quot; how)
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                We, Our advertisers, licensees, business partners, and discount sponsors may collect information
                from you in a multitude of ways, including, but not limited to, phone calls, customer service
                contacts, mobile apps, websites, and other sources.
                </li>
                <li>We collect information from customers during the process of reservation and rental transactions,
                    such as name, address, and payment card information.</li>
                <li>Personal data to provide you with exceptional rental services, including, but not limited to;
                    <ul style={{ listStyleType:'square' }}>
                    <li>
                    Name, phone number, address, date of birth
                    </li>
                    <li>Driver’s license or other forms of identification</li>
                    <li>Employer information (number, address, contact information)</li>
                    <li>Credit worthiness or other background information</li>
                    </ul>
                </li>
            </ul>
            <h5 id="4">
                3. Purposes for processing
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                Information you provide will be used to provide you with the services you request.
                </li>
                <li>We will use the contact information you provide to communicate with you.</li>
                <li>Personal data to provide you with exceptional rental services, including, but not limited to;</li>
                <li>We use “cookies” and other electronic tools to collect statistical information about your use of Our
                    websites. This information is used for research and other reasons, generally to better help Our
                    customers by showing Us how We can improve Our websites.</li>
                <li>We do use personal information for Our own analytical purposes.</li>
            </ul>
            <h5 id="5">
                4. 3rd Party Disclosures
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                We may provide your information to designated third-party service providers, rental discount
                sponsors you utilize, Our licensees, and other entities.
                </li>
                <li>We do not sell your information to unrelated third parties for purposes of marketing their products
                    of services.</li>
                <li>We may share your information for marketing purposes to those with which We have an
                    agreement to do joint advertising, subject to your consent.</li>
            </ul>
            <h5 id="6">
                5. International Transfers
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                Your information may be transferred out of your country or region of residence to countries such
                as the United States for processing and storage.
                </li>
                <li>Your information may be transferred out of your country or region of residence upon your
                    instruction.</li>
            </ul>
            <h5 id="7">
                6. Security
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                We use reasonable measures to safeguard Personal Data from theft, unauthorized use, disclosure,
                or modification.
                </li>
                <li>We aim to maintain appropriate physical, procedural and electronic safeguards to protect your
                    Personal Data.</li>
            </ul>
            <h5>
                7. Data retention
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                We generally keep customer information for as long as We believe necessary for the purpose for
                which it was collected, or as allowed by law.
                </li>
            </ul>
            <h5>
                8. Access, correction & portability
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                You will have access to review or update Personal Data that is collected from and about you, so
                you can change any information that is incorrect.
                </li>
                <li>
                We will try Our best to accommodate your request, but We reserve the right to impose certain
                restrictions and requirements.
                </li>
            </ul>
            <h5>
                9. Withdraw consent or complaints
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                Where We use consent as a basis for processing, you can always withdraw that consent.
                </li>
                <li>
                If you feel that this policy has been violated, We will work with you to resolve your concerns.
                </li>
            </ul>
            <h5>
                10. Changes
            </h5>
            <ul style={{ listStyleType:'circle' }}>
                <li>
                We may modify this Privacy Policy at any time, but changes will not apply retroactively.
                </li>
                <li>
                We will notify you when We make material changes by posting a note on the homepages of Our websites.
                </li>
            </ul>
            <p>
            Our goal is to provide Our customers with excellent services. We do business in many countries and We aim to
            comply with all privacy laws that apply to the data We collect and use. This policy is subject to compliance with
            local law. Where this policy provides a higher standard than local law, this policy will control how Hertz handles
            your Personal Data. By providing your Personal Data to Us, Our designated service providers, or other third
            parties as noted within this Policy, you consent to Our use and disclosure of your data for the operational and
            other purposes listed in this Policy.
            </p>


             <h4 id="2">1. SCOPE & CONTROLLERS</h4>
             <p>
             The Hertz Corporation, and its specific rental business affiliates and subsidiaries (including Dollar, Thrifty, and
             Firefly brands and associate entities) are data controllers for purposes of this Policy. However, We also operate
             a network of licensees in provision of Our services worldwide and are affiliated to many other companies
             through ownership. As Our licensees, affiliates, and entrusted third-party vendors are independent companies,
             they are not owned or controlled by Us and are not covered by this policy. We are not responsible for the
             privacy practices of Our licensees, and other third parties with whom you may transact.
             </p>
             <p>
             This Policy covers the information We collect about you in connection with Our vehicle rental businesses, which
             does, or can be used to identify you as an individual (“Personal Data”). It does not apply to information that
              cannot reasonably identify you as an individual. For example, but without limitation, aggregated anonymous
              data, computer operating systems, aggregated preferences, vehicle identification numbers, etc. are not Personal Data.
             </p>
             <p>
             Our websites are not directed to individuals under the age of 13, and We do not knowingly obtain Personal
             Data from such individuals.
             </p>

             <h4 id="3">2. DATA COLLECTION (WHAT & HOW)</h4>
             <p>
             We, both directly and through Our service providers, business partners, discount sponsors, licensees,
             advertisers, and booking channel providers, collect Personal Data that you provide on Our websites, on third-
             party websites, on applications, and offline in connection with any inquiries, reservations, rentals, purchases, or
             services. Information collected about your use of Our websites, applications, or other websites may be
             combined with personal or other information about you from other online or offline sources. We also will collect
             Personal Data across all the devices you use to access websites or applications of Us and Our designated
             service providers.
             </p>
             <p>
             Providing your Personal Data to Us may be required due to a legal obligation which could be a statutory or
             contractual obligation, may be on a voluntary basis or may be necessary for us to enter into the contract with
             you, depending on the purposes for which we collect and use your Personal Data as set out in this Privacy
             Statement. However, if you do not provide your Personal Data to Us this may result in disadvantages to you,
             e.g. we may not be able to provide certain products or services to you. However, unless otherwise stated, not
             providing your Personal Data will not result in legal consequence for you.
             </p>
             <p>
             Do not provide information about others unless you are authorized to do so and have obtained consent to have
             all information used, disclosed, and transferred in accordance with this Privacy Policy. By submitting
             information about others, you represent and warrant that you are authorized to do so and that you have
             received authorization from the person about whom you are providing the information and for non-EU
             residents, that person has consented to have all information used, disclosed, and transferred in accordance
             with this Privacy Policy.
             </p>
             <p>
                <b>a. TYPES OF INFORMATION COLLECTED: </b>The types of information collected regarding you and your
                interactions with Us may include, but is not limited to:
             </p>

              <table style={{ width:'100%' }}>
                <tr>
                    <td>Personal Information</td>
                    <td>Technological Information</td>
                    <td>Rental Information</td>
                 </tr>
                 <tr>
                    <td>Your name,</td>
                    <td>IP address,</td>
                    <td>Payment card information,</td>
                 </tr>
                 <tr>
                    <td>Email address,</td>
                    <td>Device ID,</td>
                    <td>Video of you and interaction with</td>
                 </tr>
                 <tr>
                    <td>Phone number,</td>
                    <td>IP address;</td>
                    <td>Us,</td>
                 </tr>
                 <tr>
                    <td>Residency address,</td>
                    <td>Browser type;</td>
                    <td>Membership organization number,</td>
                 </tr>
                 <tr>
                    <td>Date and place of birth,</td>
                    <td>Language;</td>
                    <td>Frequent flyer number,</td>
                 </tr>
                 <tr>
                    <td>Gender,</td>
                    <td>Operating system;</td>
                    <td>Loyalty program,</td>
                 </tr>
                 <tr>
                    <td>Age,</td>
                    <td>Mobile device identifiers;</td>
                    <td>Organizational affiliations,</td>
                 </tr>
                 <tr>
                    <td>Passport number,</td>
                    <td>Geo-location data;</td>
                    <td>Employee ID number,</td>
                 </tr>
                 <tr>
                    <td>Driver’s license or other ID</td>
                    <td>The state or country from which</td>
                    <td>Employer name and contact</td>
                 </tr>
                 <tr>
                    <td>photograph,</td>
                    <td>you accessed Our websites;</td>
                    <td>information,</td>
                 </tr>
                 <tr>
                    <td>Credit score and history,</td>
                    <td>The specific webpages visited;</td>
                    <td>booking location,</td>
                 </tr>
                 <tr>
                    <td>Criminal history,</td>
                    <td>The date and the time of a visit;</td>
                    <td>Rental or purchase location,</td>
                 </tr>
                 <tr>
                    <td>Background</td>
                    <td>The websites you visited</td>
                    <td>Return location,</td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>immediately before and after</td>
                    <td>Geographical areas visited,</td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>visiting Our websites;</td>
                    <td>Preferences and usage</td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>The number of links and specific</td>
                    <td>information,</td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>links you click within Our websites;</td>
                    <td>Charges incurred,</td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>The functions you use on Our</td>
                    <td>Purchase prices and details,</td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>websites;</td>
                    <td>Itinerary information,</td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>Any reservations, updates,</td>
                    <td>Data related to claims</td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>purchases, or other transactions</td>
                    <td></td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>through Our websites;</td>
                    <td></td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>The data you view or download</td>
                    <td></td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>from Our websites; and</td>
                    <td></td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>The number of times you view any</td>
                    <td></td>
                 </tr>
                 <tr>
                    <td></td>
                    <td>particular advertisements</td>
                    <td></td>
                 </tr>
            <tr>
            </tr>
            </table>

            <p><b>Sensitive Data:</b>We, both directly and through our service providers, business partners, discount sponsors,
                licensees, advertisers, and booking channel providers, may collect certain Personal Data that constitutes
                sensitive data in some countries, such as data about health conditions or membership of a trade union.
                Depending upon applicable local law, We may be unable to process such sensitive data without your
                consent. Data about your health conditions is regarded as sensitive in many countries. If you ask Us to
                accommodate a disability, such as by provision of hand controls, or if there is an accident and We need to
                work with insurance and claims management companies relating to any injury you may incur, We may need
                to process data about your health conditions. Similarly, in the EU, at least, your membership of a
                trade union or similar organization is regarded as sensitive and We may need to process this information
                if you use a CDP Number that only members of that union or organization can use.
                </p>

               <p>
               Please note that if you wish to rent with Us or Our licensees and need to provide sensitive data, we will
               use that sensitive data for Our operational uses as described in this Privacy Policy, subject to your
               consent where required under applicable law.
               </p>

                <p><b>b. METHODS AND SOURCES OF COLLECTION:</b> We, both directly and through Our service providers,
                business partners, discount sponsors, licensees, advertisers, and booking channel providers, may collect
                your information through a variety of methods. These methods may include, but are not limited to:
                </p>
                <table style={{ width:'100%' }}>
                <tr>
                    <td>On Line Off Line</td>
                    <td>Our websites;</td>
                </tr>
                <tr>
                    <td>Our kiosks;</td>
                    <td>Calls to or from Our reservation, customer service,</td>
                </tr>
                <tr>
                    <td>Our mobile “apps”;</td>
                    <td>emergency road-side assistance, customer contact</td>
                </tr>
                <tr>
                    <td>Our official third-party social network pages;</td>
                    <td>or member care centers;</td>
                </tr>
                <tr>
                    <td>Your computer’s web browser;</td>
                    <td>Interaction with Our various licensees, affiliates,</td>
                </tr>
                <tr>
                    <td>Third-party social networks;</td>
                    <td>and subsidiaries, including car sales and other</td>
                </tr>
                <tr>
                    <td>Telematics devices;</td>
                    <td>businesses;</td>
                </tr>
                <tr>
                    <td></td>
                    <td>In-person at rental locations;</td>
                </tr>
                <tr>
                    <td></td>
                    <td>In-vehicle or in-equipment technology or through</td>
                </tr>
                <tr>
                    <td></td>
                    <td>other telematic devices;</td>
                </tr>
                <tr>
                    <td></td>
                    <td>When you join Our membership programs;</td>
                </tr>
                <tr>
                    <td></td>
                    <td>In connection with a reservation (even an</td>
                </tr>
                <tr>
                    <td></td>
                    <td>abandoned or interrupted reservation);</td>
                </tr>
                <tr>
                    <td></td>
                    <td>A rental of a vehicle or equipment, or your purchase</td>
                </tr>
                <tr>
                    <td></td>
                    <td>of a vehicle or equipment;</td>
                </tr>
                <tr>
                    <td></td>
                    <td>Reservations you make with Us through licensees,</td>
                </tr>
                <tr>
                    <td></td>
                    <td>travel agents or brokers, online or in-person;</td>
                </tr>
                <tr>
                    <td></td>
                    <td>Transactions you complete with Us, Our licensees,</td>
                </tr>
                <tr>
                    <td></td>
                    <td>and agents including options you take, charges you</td>
                </tr>
                <tr>
                    <td></td>
                    <td>incur and any incidents or accidents that may</td>
                </tr>
                <tr>
                    <td></td>
                    <td>occur;</td>
                </tr>
                <tr>
                    <td></td>
                    <td>CDP Sponsors or sponsors of promotion codes,</td>
                </tr>
                <tr>
                    <td></td>
                    <td>affiliation, or special discount codes;</td>
                </tr>
                <tr>
                    <td></td>
                    <td>Consumer reporting agencies;</td>
                </tr>
                <tr>
                    <td></td>
                    <td>And other companies that have business</td>
                </tr>
                <tr>
                    <td></td>
                    <td>relationships with Us, such as Our licensees, </td>
                </tr>
                <tr>
                    <td></td>
                    <td>affiliates and business partners, including airlines, </td>
                </tr>
                <tr>
                    <td></td>
                    <td>hotels, and insurance companies. </td>
                </tr>
                <tr>
                    <td></td>
                    <td>Claims Management service providers (either </td>
                </tr>
                <tr>
                    <td></td>
                    <td>affiliated directly with Us, or operated by a third-  </td>
                </tr>
                <tr>
                    <td></td>
                    <td>party)  </td>
                </tr>

         </table>

          <p><b>c. UTILIZATION OF COOKIES AND OTHER ELECTRONIC TOOLS: </b>We and Our service providers, business
          partners, discount sponsors, advertisers, and advertising servers may place, view, or use "cookies", web
          server logs, web beacons, pixel tags, or other electronic tools to collect statistical and other information
          about your use of Our websites and other websites. This information may include information described
          above in Section 2.a
          </p>

          <p>
          We and the parties with which We work, as described in this Privacy Policy, may use the information
          collected for the purposes described in this policy, or as allowed by law; either on behalf of Us or third
          parties; including operational changes, research, analysis, to better serve visitors to Our websites (such
          as by enabling log-in, providing access to certain sections of websites, providing customized content, or
          presenting online advertising tailored to you or your interests as described further below), to compile
          aggregate and anonymous information about usage of Our websites and other websites, other statistics,
          and more.
          </p>
          <p>
          If you have deleted and disabled cookies, these uses will not be possible to the extent they are based on
          cookie information.
          </p>

          <p><b>d. WEB ADVERTISING:  </b>We, Our designated service providers, or third-party advertisers or their
          advertising servers, may place or recognize unique cookies on your computer or use other electronic
          tools in order to help display advertisements that you see on Our websites or on other websites.
          Information about your visits to, and activity on, Our websites and other websites, is used, alone or
          in combination with other information, to display on your device screen advertisements that may be of
          particular interest to you. We may use web beacons, pixel tags, or other such technologies provided by
          third-party advertising companies, to help manage and optimize Our online advertising and product
          performance. These technologies enable Us to recognize user visits to our websites, and to learn which
          banner ads bring users to Our websites.
          </p>
          <p>
          As the internet and other eCommerce channels continue to develop, We may deploy and utilize different
          types of technologies to collect data regarding your visit or usage.
          </p>
          <p>
          <b>e. VEHICLE MANUFACTURERS: </b>Please note that the rental vehicles you operate may collect personal
          information about you. We are not responsible for these activities, and such collection (and use) is
          subject to the vehicle manufacturer’s policies and notices.
          </p>

           <h4 id="4">3. PURPOSES FOR PROCESSING</h4>
                <p> <b>a. OPERATIONS AND SERVICES:</b>We, both directly and through our service providers, business partners,
                discount sponsors, licensees, and booking channel providers, may use your information to provide you
                with the services or products you request from Us.
                </p>
                <p>
                We may use your information to communicate with you regarding any reservation you initiate or rental
                transaction; your membership/status in one of Our membership programs; or changes to the terms or
                features of any of Our membership programs to which you belong.
                </p>
                <p>
                We therefore process your Personal Data for these purposes to the extent necessary to perform our
                contract with you or to take steps at your request prior to entering into a contract with you.
                </p>
                <p>
                For United States Residents, so that We may communicate with you, you give Us your consent to call
                you on or send text messages to your mobile telephone/device. You also consent to Our use of auto-dialers
                and pre-recorded messages in connection with any such telephone call or text message, including calls
                or texts to mobile telephone numbers. We will not charge you for such calls or texts.
                </p>

                <p> <b>b. OUR MARKETING: </b>We, both directly and through Our service providers, business partners, discount
                sponsors, licensees, advertisers, and booking channel providers, may use your Personal Data to provide
                you with marketing information, special offers, and promotions via various means including e-mail, in
                    accordance with applicable law.
                </p>
                <p>
                Where We have obtained your consent to send these marketing communications to you, We therefore
                process your Personal Data for these purposes on the basis of your consent. However, where permitted
                by applicable law We may lawfully use your Personal Data to send you such marketing communications
                (including via email) without your consent. Where permitted by applicable law We may also process your
                Personal Data for these marketing purposes where necessary for Our legitimate interests, which include
                promoting Our products and services, special offers and promotions which may be of interest to you.
                </p>
                <p>
                You can unsubscribe from receiving such messages at any time by contacting Us at the details below
                under "Contact Us" as well as the unsubscribe link in each e-mail message. You can also request at any
                time that We do not to use your Personal Data covered by this Privacy Policy to provide you with special
                offers and promotions by contacting Us at the details below under “Contact Us”. Please note that if you
                exercise these choices, you will continue to receive communications concerning your account and
                products and services you requested, and in response to any requests for information by you. Please also
                note that this opt-out process may take some time to complete, consistent with applicable law. Third-
                party rental sponsoring organizations are solely responsible for their own practices, and an unsubscribe
                request must be sent to any such organization from which you would like to stop receiving marketing
                materials.
                </p>

                <p> <b>c. THIRD-PARTY PURPOSES: </b>As part of Our Services, We have engaged with third-party organizations
                that sponsor the CDP, member, employee, or other number used by you to complete a rental or purchase
                (“Sponsoring Organization”). As a result of Our relationship with these Sponsoring Organizations, We
                may be under an obligation to provide the third party with details about you and your use of Our
                services as they relate to your relationship with the Sponsoring Organization.
                </p>

                <p>
                We Process your Personal Data in relation to Sponsoring Organizations to the extent necessary for
                performance of our contract for rental or purchase where you use a CDP, member, employee, or other
                number.
                </p>
                <p>
                Sponsoring Organizations may have different privacy practices than We do, and We recommend you
                review the Sponsoring Organization’s privacy policy for the purposes which they will use your
                information. As We do not control the Sponsoring Organization’s privacy practices, they may not be the
                same as Ours. However, because of your relationship with the Sponsoring Organization, they can use
                Personal Data which they receive from Us for the purposes specified in their privacy policies or similar
                statements.
                </p>
                <p> <b>d. NORMAL COURSE OF BUSINESS:  </b>We may also process your Personal Data and other information if
                such processing is necessary:
                </p>
                <p>
                (a) to comply with the law or in response to a subpoena, court order, law enforcement request, or other
                legal process; (b) to protect the interests, rights, safety, or property of Us or others; (c) to enforce any
                terms of service on Our websites or the terms and conditions of any rental, purchase, or utilization; (d) to
                provide you and others with the services or products requested by you or your designated representative,
                and to perform other activities related to such services and products, including billing and collection; (e)
                to provide you with special offers or promotions from Us that may be of interest to you, where permitted;
                (f) as part of a business transaction where all or some of Our assets are bought, sold, or otherwise
                transferred by act of law or contract; or (g) to operate Our systems properly.
                </p>
          <h4 id="5">4. DISCLOSURES TO AFFILIATES AND THIRD PARTIES:</h4>
                <p> <b>a. THIRD-PARTY PROVIDERS:   </b>For the purposes described in this Policy, We may share your personal and
                other information with our service providers, business partners, discount sponsors, licensees, assigns,
                advertisers, and booking channel providers. We may share with other third parties aggregate or
                anonymized information about Our website users, such as your use of this website or other websites, and
                the services provided on this website or other websites, as well as any rental, purchase, or utilization
                information. We may provide information about you and your interactions with Us to any third-party
                organization that sponsors the CDP, member, employee, or other number used by you to complete a
                rental or purchase. We may also share your Personal Data with a sponsor or other third party that
                provides you with special offers or promotions that may be of interest to you ("Third-Party Provider")
                where permitted. You may instruct Us at any time not to share your Personal Data covered by this
                Privacy Policy with such Third-Party Providers by contacting us in the manner set forth below.. Please
                note that (i) this opt-out process may take some time to complete, consistent with applicable law; and (ii)
                even after such opt-out process is completed, your personal and other information may continue to be
                shared with our affiliates (including affiliated websites under common ownership or control) and
                designated service providers.
                </p>

                <p> <b>b. SPONSORING ORGANIZATIONS:  </b>We may provide personal information about you and your
                interactions with Us to those third-party organizations that sponsor the CDP, member, employee, or
                other number used by you to complete a rental or purchase. The use by such sponsoring thirdparty of
                your information, including information regarding your interactions with Us, is subject to that
                organizations privacy policy and relationship with you. We are not liable for and make no assertions of
                any particular uses of information by such organizations.
                </p>
                <p> <b>c. SOCIAL MEDIA:  </b>If you participate in certain public features of our websites, apps, or social media
                websites/apps, please note that any information you or others voluntarily disclose through use of such
                features, becomes available to the public and/or other users whom you have designated. If you choose
                to provide access credentials to designated individuals, please be aware that any information you
                provide to Us may be visible to such individuals. We are not responsible for the information that you or
                others choose to disclose publicly and neither Our nor others’ use of such information is subject to this
                Privacy Policy.
                </p>
                <p> <b>d. LINKS TO THIRD PARTIES:  </b>We may provide links to third-party websites, or may be linked to from third-
                party websites. Since We do not control third-party sites, and We are not responsible for any information
                you may provide while on such sites, We encourage you to read the privacy policies on those websites
                before providing applicable third-parties with your information.
                </p>
                <p> e. LICENSEES: We may provide your Personal Information to Our licensees when it is necessary to
                    complete a reservation or rental, to assist with a customer service issue, or to perform any other
                    activities related to open or previous services or products which We have provided to you.
                </p>
                <p> <b>f. GENERAL COURSE OF BUSINESS:   </b>We may also disclose your personal and other information to
                unaffiliated third parties if We believe in good faith that such disclosure is necessary: (a) to comply with
                the law or in response to a subpoena, court order, law enforcement request, or other legal process; (b) to
                protect the interests, rights, safety, or property of Us or others; (c) to enforce any terms of service on Our
                websites or the terms and conditions of any rental, purchase, or utilization; (d) to provide you and others
                with the services or products requested by you or your designated representative, and to perform other
                activities related to such services and products, including billing and collection; (e) to provide you with
                special offers or promotions from Us that may be of interest to you; (f) as part of a business transaction
                where all or some of Our assets are bought, sold, or otherwise transferred by act of law or contract; or
                (g) to operate Our systems properly.
                </p>
           <h4 id="6">5. INTERNATIONAL TRANSFERS</h4>
           <p> Some of the uses and disclosures mentioned in this Privacy Policy may involve the transfer and processing of
               your Personal Data to and in various countries around the world, that may have different levels of privacy
               protection than your country of residence or interaction with Us.
           </p>
           <p> <b>E.U. – U.S. PRIVACY SHIELD FRAMEWORK:</b> The Hertz Corporation and its subsidiaries in the U.S. (individually
               and collectively, the "Company") participates in the EU-U.S. Privacy Shield Framework (the "Framework").
           </p>
           <p> Company's participation in the Framework applies to Personal Data received in the United States from the
               European Union ("EU"). We are committed to subjecting such EU Personal Data to the Framework to the extent
               that We have received it in reliance on the Framework, including its Principles of Notice, Choice, Accountability
               for Onward Transfer, Security, Data Integrity and Purpose Limitation, Access, and Recourse, Enforcement and
               Liability. To learn more about the Framework, visit the U.S. Department of Commerce's Privacy Shield List at
               https://www.privacyshield.gov/list.
           </p>
           <p> Where We transfer your Personal Data outside of the European Economic Area other than to Hertz Corporation
               and its subsidiaries in the US which participate or any other organization in the US which participates in the
               Framework, or to a country which is not covered by an adequacy decision from the European Commission We
               implement standard contractual clauses. You can request a copy of these standard contractual clauses by
               contacting us as set out in "Contact Us" below.

           </p>
           <h4 id="7">6. COOKIES AND ONLINE ADVERTISING CHOICES</h4>
           <p> Many browsers are set to accept cookies by default. You may be able to set your browser to disable cookies, or
               alert you when cookies are being sent. Many mobile devices allow you to disable the ability for geo-location
               information to be collected from your mobile device. The help function on most browsers and mobile devices
               contains instructions on how to set your browser to notify you before accepting cookies, disable cookies, or
                disable the collection of geo-location data.
           </p>
           <p>You need to set each browser, on each device you use to view websites. If you disable cookies or refuse to
               accept a request to place a cookie, it is possible that some parts of Our websites or other websites will not
               function properly, and the advertising you receive when you visit Our websites or other websites may not be
               tailored to your interests. We may not respond to a web browser’s “do not track” signal, or other mechanism
               that indicates a request to disable online tracking of individuals who use or visit Our websites.
           </p>
           <p>You need to set each browser, on each device you use to view websites. If you disable cookies or refuse to
               accept a request to place a cookie, it is possible that some parts of Our websites or other websites will not
               function properly, and the advertising you receive when you visit Our websites or other websites may not be
               tailored to your interests. We may not respond to a web browser’s “do not track” signal, or other mechanism
               that indicates a request to disable online tracking of individuals who use or visit Our websites.
           </p>
           <p>We adhere to the Self-Regulatory Principles for Online Behavioral Advertising. To "opt out" of advertising
               cookies placed by the Network Advertising Initiative's ("NAI") online behavioral advertising member networks,
            and thereby limit the tracking of your online activity and the targeted advertising you receive, please <a  href="http://optout.networkadvertising.org/?c=1#!/" target="_bank">click here.</a>
           </p>
           <p>To opt out of advertising cookies for Your Online Choices if you are based in the EU, please click here.<a  href="http://www.youronlinechoices.eu/" target="_bank">click here.</a>
           </p>
           <p>Our designated service providers assist Us with advertisement display functions and related analytics for Our
               websites. To view information or opt out of Google Analytics for Display Advertising, please <a  href="https://policies.google.com/technologies" target="_bank">click here.</a>.
               Note that even if you exercise choice for targeted advertising, you will still receive general online advertising.
               Information regarding you and any interactions with Us may be collected and utilized to provide you with
               targeted advertising on the web.
           </p>
           <p>With regard to mobile apps, any app’s collection and use of Personal Data that is materially different from
               what’s described in this Policy will be supplemented by an individual Privacy Policy that will require acceptance
               for that specific app.
           </p>
           <p>In addition to the options provided by your mobile operating systems, you may opt out of the collection of
               information on mobile apps as follows:
           </p>

           <ul>
               <li><u>Uninstalling the app.</u> You can stop all collection of information by the app by uninstalling the app. You
                   may use the standard uninstall processes as may be available as part of your mobile device or via the
                   Mobile Application marketplace or network from which you downloaded the app; </li>
              <li><u>Opt out of interest-based advertising.</u> See the instructions below or contact Us for information about
              how to opt out from the use of information to serve targeted advertising by advertisers and/or third-
              party network advertisers. Note that the effect of opting out of targeted advertising will be to prevent
              targeted advertising, but will not prevent you from seeing all advertisements. Information may still be
              collected and used for other purposes (such as research, online services analytics or internal operations,
              and to enforce your opt-out preferences): </li>
              <li><u>For Apple users: </u> iOS 7 or higher, you can change your settings in the following location: Settings &gt;
              Privacy &gt; Advertising. iOS 6, you can change your settings in the following location: Settings &gt; General &gt;
              About &gt; Advertising. For further information please see Apple’s website <a  href="https://www.apple.com/" target="_bank">here</a> </li>
              <li><u>For other major mobile platforms:</u> Open the platform account settings, select “Ads”.</li>
              <li><u>Opt out of location data.</u> Go to “settings” on your mobile device to opt out of the collection of location
              data.</li>
              <li><u>Opt out of cross-app data collection. </u> The Digital Advertising Alliance (“DAA”) offers a separate choice
              tool for the collection of cross-app data on a mobile device for interest-based advertising and other
              applicable uses. To exercise choice for companies participating in this choice tool, you can install the
              DAA’s AppChoices <a  href="https://youradchoices.com/appchoices" target="_bank">app.</a></li>
            </ul>

            <h4 id="8">7. SECURITY</h4>
                    <p>a. We use reasonable administrative, technical, personnel, and physical measures (a) to safeguard
                        Personal Data against loss, theft, unauthorized use, disclosure, or modification; and (b) to ensure the
                        integrity of your Personal Data. To help Us protect your privacy, you should maintain the secrecy of any
                        logon IDs and passwords, Member numbers, or other identifiers or credentials you may have set up or
                        were provided with in connection with your participation in or use of Our products, services, or websites.
                </p>
                <p>As you may be aware, there is no completely secure method of transmitting or storing data. Although
                    their physical characteristics are different, postal mail, telephone calls, text messages, faxes and
                    transmissions over the Internet or wireless networks all present possibilities of loss, misrouting,
                    interception and misuse of the data that is transmitted. If you have reason to believe that any account
                        with Us is no longer secure, you must immediately contact Us.
                </p>
                <p>We try to strike a balance between the security of your data and your convenience. As a result, We may
                    sometimes use a method of communication that is less secure than a less convenient alternative. For
                    example, but not limitation, We may send you an e-mail or a text message in unencrypted form (i.e.
                    instantly readable) because many of Our customers are unable to access encrypted (i.e. coded) e-mail or
                    messages. This means that Our message, if misrouted or intercepted, could be read more easily than
                    encrypted messages. Such messages may contain Personal Data. Please do not include confidential
                    information, such as your credit card number or account passwords, in any e-mail or text you send to Us
                    or on any posting you make to a public area of a third-party social network page, especially since any
                    such posting immediately becomes public. For a more secure way to communicate with Us over the
                    Internet, please click on the “Contact Us ” link on any of Our websites.
                </p>

           <h4 id="9">8. DATA RETENTION & INTEGRITY</h4>
                <p>b. We retain personal data about Our customers for as long as necessary for the purposes for which it
                    was collected, or unless otherwise allowed by law. Information is stored and accessed in various
                    locations, and cloud services and storage may be utilized. Servers which store information are primarily
                    located in the United States and Europe, although storage may occur in other locations as well.
                </p>
           <h4 id="10">9. ACCESS, CORRECTION & PORTABILITY</h4>
                <p>a. To access, review, or update your Personal Data covered by this Privacy Policy, please contact Us at
                    the details set out in the “Contact Us” section below. While We will make reasonable efforts to
                    accommodate your request, We also reserve the right to impose certain restrictions and requirements on
                    such access requests, if allowed or required by applicable laws. If you are a member of one of Our
                    membership or rewards programs, you may update your member profile by logging into your applicable
                    member profile.
                </p>
                <p>b. EU residents have the right to: (a) request rectification of your Personal Data; (b) object to
                    the processing of your Personal Data for direct marketing purposes; (c) object to the processing of your
                    Personal Data (including profiling) where our legal basis for processing your Personal Data is where such
                    processing is necessary for our legitimate interests; (d) request erasure of your Personal Data; (e) request
                        restriction of your Personal Data; (f) exercise your right to data portability; and (g) object to automated
                        decision making (including profiling).
                </p>
                <p>c. In addition, where we process the Personal Data of EU residents on the basis of their consent as
                        mentioned in this Privacy Policy, they can withdraw that consent at any time.
                </p>
                <p>You can make a request to us to exercise any of these rights by contacting Us at the at the details set
                    out in "Contact Us" section below.
                </p>
                <p>
                <b>d. RIGHT TO BE FORGOTTEN: </b>We may retain your Personal Data as is necessary to fulfill the purposes for
                which the Personal Data was collected. We may also retain this Personal Data as required by law or
                contract, in order to fulfill Our legal obligations and protect Our legal rights. However, once the purpose
                for the collection is no longer valid, and there is no legal reason for Us to retain your Personal Data, you
                    may request Us to delete your Personal Data. You may make this request by contacting Us via
                    the mechanism provided below in the “Contact Us” section of this Policy. If We are unable to delete your
                    Personal Data due to one of the reasons described in this Policy, We will provide you with the reason We
                    are unable to fulfill your request.
                </p>
                <p> <b>e. CALIFORNIA RESIDENTS:  </b>California’s “Shine the Light” law – Civil Code section 1798.82 - permits
                residents of California to opt-out of disclosure of Personal Data to third parties for their direct marketing
                purposes. You may choose to opt-out of the sharing of your Personal Data with third parties for
                marketing purposes at any time by submitting a request in writing to Our contact address below. Please
                note that this opt-out does not prohibit disclosure made for non-marketing purposes. California law also
                permits residents of California to request and obtain from Us once per calendar year, free of charge, a
                list of (i) the third parties (if any) to which Personal Data was disclosed for their direct marketing
                purposes in the prior calendar year and (ii) the categories of Personal Data disclosed to those third
                parties.
                </p>
                <p>If you are a California resident and would like to request this information, please submit your request in
                    writing to Our contact address shown in Section 10 below. Your request must include: (i) the phrase
                    “Your California Privacy Rights”; (ii) your name, street address (no PO boxes), city, state and zip code;
                    and, if applicable, (iii) your e-mail address if you wish to receive a response via e-mail. When submitting
                    your request by mail, please include the phrase “Your California Privacy Rights” on the outer mailing
                    envelope. We will not accept requests made by telephone or facsimile.
                </p>

          <h4 id="11">10. COMPLAINTS</h4>
          <p>Please contact Us as specified below if you have any questions, need access to your Personal Data, or
              otherwise need assistance. We also are responsible for third-party agents that are processing such data on our
              behalf, unless we prove that we are not responsible for the event giving rise to the damage. We are also subject
               to the investigatory and enforcement powers of the Federal Trade Commission with respect to the Framework.
                Should you have a concerns or complaints about the handling of your Personal Data being in violation of this
                 Privacy Policy, you may contact us directly via the methods described below in the “Contact Us” section. We
                  will work to respond and resolve your complaints in an expeditious manner.
           </p>
           <p>If you are unable to satisfactorily resolve your concerns with us, you may contact the FTC with your concerns.
           </p>
           <p>If you are an EU resident and you have an unresolved concern about Personal Data that We or the FTC have
               not addressed satisfactorily, We have committed to cooperate with the panel established by the EU Data
               Protection Authorities to serve as Our independent dispute resolution body for the Framework.
           </p>
           <p>In addition, under certain conditions, more fully described on the Privacy Shield website, EU data subjects may
               invoke binding arbitration for non-monetary issues when other dispute resolution procedures have been
                exhausted.
           </p>

           <h4 id="12">11. Contact Us</h4>

            <p>Please contact Us by emailing privacy@hertz.com, or for EU residents - euprivacy@hertz.com or writing to the
                 address below if you have any questions, wish to exercise your rights of access, or seek other assistance as
                  described above.
           </p>

           <p>
            <address>
            The Hertz Corporation
            Attention: Legal-Privacy
            8501 Williams Rd.
            Estero, FL 33928
            USA
            </address>
           </p>
           <p>We do business in many countries and aim to comply with the privacy laws applicable to the Personal Data we
                collect and use.
           </p>

           <h4 id="13">12. CHANGES</h4>
           <p>We reserve the right to change this Privacy Policy at any time for any reason by posting revisions on this
               Webpage or on applicable apps or other sites. Such changes will be effective upon posting, but will not apply
               retroactively. Whenever We make a material change, We will note the date of such update in the introductory
               paragraph above, and post a note on the home page of our applicable websites.
           </p>







           <p>
           <a  href="https://www.hertz.com/rentacar/privacypolicy/index.jsp?targetPage=privacyPolicyView.jsp" target="_bank"> <b>Privacy Policy</b></a>
          </p>
          <p>
           <a  href="https://www.hertz.com/rentacar/customersupport/index.jsp?targetPage=hTRUCountrySelectPopupView.jsp" target="_bank"> <b>Contact Us</b></a>
          </p>
          <p>
           <a  href="https://www.jobs.net/jobs/hertz-corporation/join?joinpath=Exportablejoin?" target="_bank"> <b>Careers</b></a>
          </p>
          <p>
           <a  href="https://www.hertz.com/rentacar/reservation/" target="_bank"> <b>Full Website</b></a>
          </p>
          <p>
           <a  href="https://secure.opinionlab.com/ccc01/o.asp?id=cLHwJLaM" target="_bank"> <b>Feedback</b></a>
          </p>



        </div>
    </div>
    );
};
